"use client";

import { useRef, useState } from "react";
import { Card, CardContent } from "../ui/card";
import { ChevronLeft, ChevronRight, Shield } from "lucide-react";
import { Link } from "react-router-dom";
export default function InsuranceSection() {
  const scrollRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const insuranceCompanies = [
    { name: "ICICI Lombard", logo: "https://mamshospitals.com//Royal_Sundaram.png" },
    { name: "HDFC ERGO", logo: "https://mamshospitals.com//2560px-reliance-general-insurance-svg.png"},
    { name: "Bajaj Allianz", logo: "https://mamshospitals.com//Star_Health_and_Allied_Insurance.svg.png" },
    { name: "Star Health", logo: "https://mamshospitals.com//265-2654251_kotak-mahindra-general-insurance-company-limited.png" },
    { name: "New India Assurance", logo: "https://mamshospitals.com//godigit-sixteen_nine.avif" },
    // { name: "Oriental Insurance", logo: "https://mamshospitals.com//Royal_Sundaram.png" },
    { name: "United India Insurance", logo: "https://mamshospitals.com//Magma.png" },
    { name: "National Insurance", logo: "https://mamshospitals.com//future_generali.png" },
    { name: "Reliance General", logo: "https://mamshospitals.com//acko-logo-1920x1080.png" },
    { name: "Tata AIG", logo: "https://mamshospitals.com//edelweiss.jpg" },
    { name: "Cholamandalam MS", logo: "https://mamshospitals.com//iffco-tokio-logo-png_seeklogo-616963.png" },
    { name: "Future Generali", logo: "https://mamshospitals.com//manipal.png" },
    { name: "Bharti AXA", logo: "https://mamshospitals.com//Bajaj-Allianz-General-Insurance-Co-Ltd.jpg" },
    { name: "SBI General", logo: "https://mamshospitals.com//TPA__medi_assist.png" },
    { name: "Iffco Tokio", logo: "https://mamshospitals.com//Chola_MS.png" },
    { name: "Max Bupa", logo: "https://mamshospitals.com//niva-bupa-health-insurance.avif" },
    { name: "Apollo Munich", logo: "https://mamshospitals.com//Logo_Liberty_Insurance.png" },
    { name: "Cigna TTK", logo: "https://mamshospitals.com//sriram.jpg" },
    { name: "Religare Health", logo: "https://mamshospitals.com//PHS_Logo.png" },
    { name: "Care Health", logo: "https://mamshospitals.com//63344059b72794c0f8ff1b87_logo__Aditya-birla.png" },
    { name: "Niva Bupa", logo: "https://mamshospitals.com//Genius.png" },
    { name: "Aditya Birla", logo: "https://mamshospitals.com//632085285d1a9d213e365cb1_TPA__ericson.png"},
    { name: "Kotak General", logo: "https://mamshospitals.com//62ebb5454447c185f1c58ea8_Health-india-tpa-1.jpg" },
    { name: "Raheja QBE", logo: "https://mamshospitals.com//united_healthcare.png" },
    { name: "Universal Sompo", logo: "https://mamshospitals.com//TPA__med_save.png" },
    { name: "Liberty General", logo: "https://mamshospitals.com//alankit.jpeg" },
    { name: "Go Digit", logo: "https://mamshospitals.com//care.png" },
    { name: "Acko General", logo: "https://mamshospitals.com//safeway_insurance_tpa_pvt_ltd_cover.jpeg" },
    { name: "Zuno General", logo: "https://mamshospitals.com//TPA__Vidal_Health.png" },
    { name: "Magma HDI", logo: "https://mamshospitals.com//EAST-WEST-ASSIST-TPA-INSURANCE.png" },
    { name: "Magma HDI", logo: "https://mamshospitals.com//md_india.png" },
    { name: "Magma HDI", logo: "https://mamshospitals.com//download.png" },
    { name: "Magma HDI", logo: "https://mamshospitals.com//62d953386d97633d026a5a0c_FHPL.jpg" },
  ];
  
  

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-8 md:py-16 px-0 md:px-4 bg-apple-gray-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Shield className="h-8 w-8 text-apple-teal" />
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500">Insurance Partners</h2>
          </div>
          <p className="text-apple-gray-400 max-w-2xl mx-auto">
            We accept insurance from 30+ leading companies to make quality healthcare accessible and affordable for you.
          </p>
        </div>

        {/* Scroll Buttons */}
        <div className="relative">
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-apple-gray-50 transition-colors"
            aria-label="Scroll left"
          >
            <ChevronLeft className="h-6 w-6 text-apple-gray-400" />
          </button>
          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-apple-gray-50 transition-colors"
            aria-label="Scroll right"
          >
            <ChevronRight className="h-6 w-6 text-apple-gray-400" />
          </button>

          {/* Insurance Logos */}
          <div
            ref={scrollRef}
            className="flex gap-4 overflow-x-auto scrollbar-hide pb-4 px-3 md:px-12"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {insuranceCompanies.map((company, index) => (
              <Card
                key={index}
                className="flex-shrink-0 w-40 h-24 border-apple-gray-100 hover:border-apple-teal transition-all duration-300 hover:shadow-md rounded-2xl"
              >
                <CardContent className="pt-4 p-4 h-full flex items-center justify-center">
                  <img
                    src={company.logo || "/placeholder.svg"}
                    alt={`${company.name} logo`}
                    className="max-w-full max-h-full object-contain filter "
                  />
                </CardContent>
              </Card>
            ))}
          
          </div>
           </div>
        <img src="https://mamshospitals.com//Insurancenew.png" className="w-fit rounded shadow-lg "/>
        <div class="flex justify-center items-center "> 
{/*           
          <div className="apple-button-secondary bg-white text-apple-teal hover:bg-apple-gray-50" onClick={() => setIsOpen(true)}>
            See More
          </div> */}
          {/* Modal Overlay */}
          {isOpen && (
            <div className="relative inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 my-auto">
              {/* Modal Content */}
              <div className="bg-white rounded-lg shadow-lg p-10 w-full max-w-md relative">
                <div className="flex justify-end absolute z-99 right-2 top-2">
                  <button
                    onClick={() => setIsOpen(false)}
                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                  >
                    Close
                  </button>
                </div>
                <img
                  src="https://mamshospitals.com//Insurance-img.jpg"
                  className="w-fit rounded shadow-lg "
                />
                
              </div>
            </div>
          )}
              
        </div>
         
        {/* Benefits Section */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1 */}
          <Card className="border-apple-gray-100 rounded-3xl">
            <CardContent className="p-6 text-center">
              <div className="bg-apple-teal/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-apple-teal" />
              </div>
              <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Cashless Treatment</h3>
              <p className="text-apple-gray-400">
                Get treatment without any upfront payment with our cashless facility for insured patients.
              </p>
            </CardContent>
          </Card>

          {/* Card 2 */}
          <Card className="border-apple-gray-100 rounded-3xl">
            <CardContent className="p-6 text-center">
              <div className="bg-apple-teal/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-apple-teal"
                >
                  <path d="M9 12l2 2 4-4" />
                  <path d="M21 12c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h18z" />
                  <path d="M3 10v4c0 .552.448 1 1 1h16c.552 0 1-.448 1-1v-4" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Quick Approvals</h3>
              <p className="text-apple-gray-400">
                Fast insurance claim processing and approvals to ensure you get timely medical care.
              </p>
            </CardContent>
          </Card>

          {/* Card 3 */}
          <Card className="border-apple-gray-100 rounded-3xl">
            <CardContent className="p-6 text-center">
              <div className="bg-apple-teal/10 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-apple-teal"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">Dedicated Support</h3>
              <p className="text-apple-gray-400">
                Our insurance desk team helps you with all insurance-related queries and documentation.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Contact Section */}
        {/* <div className="mt-12 text-center">
          <div className="bg-white rounded-3xl p-8 border border-apple-gray-100">
            <h3 className="text-2xl font-semibold text-apple-gray-500 mb-4">Insurance Query?</h3>
            <p className="text-apple-gray-400 mb-6">
              Not sure if your insurance is accepted? Contact our insurance desk for assistance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:+917399999981" className="apple-button justify-center">
                Call Insurance Desk
              </a>
              <a href="mailto:insurance@mamshospitals.com" className="apple-button-secondary">
                Email Us
              </a>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}
